import React from 'react';

const CloseWorkflowModalIcon = ({ backgroundColor, height, width }) => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width={width} height={height} viewBox="0 0 46 46">
        <g>
            <g id="Delete_1_">
                <g>
                    <path d="M23,0C10.298,0,0,10.298,0,23s10.298,23,23,23s23-10.298,23-23S35.702,0,23,0z M23,42C12.507,42,4,33.493,4,23     S12.507,4,23,4s19,8.507,19,19S33.493,42,23,42z M30.305,16.403l-0.707-0.707c-0.586-0.585-1.537-0.585-2.123,0L23,20.171     l-4.475-4.475c-0.586-0.585-1.536-0.585-2.121,0l-0.708,0.707c-0.585,0.586-0.585,1.536,0,2.122L20.171,23l-4.475,4.475     c-0.585,0.586-0.585,1.536,0,2.121l0.708,0.709c0.585,0.584,1.535,0.584,2.121,0L23,25.829l4.475,4.476     c0.586,0.584,1.537,0.584,2.123,0l0.707-0.709c0.584-0.585,0.584-1.535,0-2.121L25.829,23l4.476-4.475     C30.889,17.939,30.889,16.989,30.305,16.403z" fill={backgroundColor} />
                </g>
            </g>
        </g>
    </svg>
);
export default CloseWorkflowModalIcon;
